import {AfterViewInit, Component, inject, input, InputSignal, signal, WritableSignal} from '@angular/core';
import {QRCodeComponent} from "angularx-qrcode";
import {CmsApiService} from "../../core/cms-api.service";
import {GetArtifactsParams} from "../../core/definitions/get-artifacts-params";
import {QrCodeExtraDataOption} from "../object-page-qr-code-dialog/object-page-qr-code-dialog";
import {SettingsService} from "../../core/settings.service";

@Component({
  selector: 'app-object-page-qr-code',
  imports: [
    QRCodeComponent
  ],
  templateUrl: './object-page-qr-code.html',
  styleUrl: './object-page-qr-code.scss',
})
export class ObjectPageQrCode implements AfterViewInit {
  private readonly cms: CmsApiService = inject(CmsApiService);
  private readonly settings: SettingsService = inject(SettingsService);

  artifacts: WritableSignal<any[]> = signal([]);
  language: WritableSignal<string> = signal('no');

  artifactIds: InputSignal<string[]> = input([]);
  displayExtraData: InputSignal<QrCodeExtraDataOption[]> = input([]);

  ngAfterViewInit() {
    this.initializeView(this.artifactIds());
    this.language.set(this.settings.getClientConfig()?.CLIENT_LANGUAGE ?? 'no');
  }

  initializeView(artifactIds: string[]): void {
    let params = new GetArtifactsParams();

    params.artifact_ids = artifactIds;
    params.suppressErrHandler = true;
    params.get_source = false;

    this.cms.getArtifacts(params).then((result) => {
      if (result.length) {
        this.artifacts.set(result);
      }
    })
  }
}

